import { useState } from 'react'
import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { minutesToMilliseconds } from 'date-fns'
import {
  fetchFiles,
  FileDownloadResult,
  FileDownloadProgress,
} from 'src/services/fileFetch'

type Props = {
  files: { id: string; url: string }[]
}

export const useFilesQuery = ({
  files,
}: Props): UseQueryResult<FileDownloadResult> & {
  progress: FileDownloadProgress
} => {
  const [progress, setProgress] = useState<FileDownloadProgress>({})

  const query = useQuery<FileDownloadResult>({
    queryKey: ['files', ...files.map(file => file.url)],
    queryFn: () =>
      fetchFiles({
        filesToFetch: files,
        onProgress: progress => {
          setProgress(progress)
        },
      }),
    staleTime: minutesToMilliseconds(60),
  })

  return { ...query, progress }
}
